const filesTypography = {
  label: 'GEEQUIP support files'
};

export default filesTypography;
